import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useBookingContext } from "../context/BookingContext";
import Modal from "react-responsive-modal";
import moment from "moment";
import OutOfTownModal from "./OutOfTownModal";
import { useTranslation } from "react-i18next";

function InAndOutTownUsage() {
  const { dateUsage, openOutOfTownModal, setOpenOutOfTownModal } = useBookingContext();
  // const inTownData = dateUsage?.inTown;
  const datas = dateUsage?.outOfTown;
  const zone1 = datas?.filter((i) => i?.zone?.includes(1));
  const zone2 = datas?.filter((i) => i?.zone?.includes(2));
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        spacing={3}
        padding={"3rem"}
        sx={{
          borderBottom: "1px solid rgba(119, 119, 119, 0.6235294118)",
        }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Container
            onClick={() => {
              setOpenOutOfTownModal(true);
            }}
            // dates={inTownData?.map((v) => moment(v?.date).format("D"))}
            title={t("in_town_usage")}
            // btnTitle="Add in-town usage"
          >
            <div style={{ color: "#706f7b" }}>{t("denpasar_jimbaran_etc")}</div>
          </Container>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Container
            title={t("out_of_town_usage")}
            btnTitle={t("add_out_off_town")}
            onClick={() => {
              setOpenOutOfTownModal(true);
            }}
          >
            <Stack spacing={1} mt={1}>
              <Stack>
                <p style={{ fontWeight: "600" }}>{t("zone_1")}</p>
                <p style={{ color: "#706f7b" }}>{t("kerobokan_etc")}</p>
                {zone1?.length ? (
                  <Box sx={{ color: "green" }}>
                    <span>{zone1?.map((v) => moment(v.date).format("DD MMM"))?.join(",")}</span>
                  </Box>
                ) : null}
              </Stack>
              <Stack>
                <p style={{ fontWeight: "600" }}>{t("zone_2")}</p>
                <p style={{ color: "#706f7b" }}>{t("karangasem_etc")}</p>
                {zone2?.length ? (
                  <Box sx={{ color: "green" }}>
                    <span>{zone2?.map((v) => moment(v.date).format("DD MMM"))?.join(",")}</span>
                  </Box>
                ) : null}
              </Stack>
              <div className="out_of_town_note">
                <i className="fa-solid fa-circle-exclamation"></i> <p>{t("this_rate_valid")}</p>
              </div>
            </Stack>
          </Container>
        </Grid>
      </Grid>
      {openOutOfTownModal && (
        <Modal
          open={openOutOfTownModal}
          showCloseIcon={false}
          onClose={() => {}}
          styles={{
            root: { zIndex: 9999999991 },
            modal: {
              minWidth: 300,
            },
          }}
        >
          <OutOfTownModal />
        </Modal>
      )}
    </>
  );
}

export default InAndOutTownUsage;
const Container = ({ title, children, btnTitle, onClick, dates }) => {
  return (
    <Box>
      <Typography fontSize={13} fontWeight="600">
        {title}
      </Typography>
      <Grid
        container
        sx={{
          alignItems: "end",
        }}
      >
        <Grid item xs={12} sm={6}>
          {children}
          {dates?.length ? <div>Dates : {dates.join(",")}</div> : null}
        </Grid>
        <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
          {btnTitle ? (
            <Button
              variant="contained"
              onClick={onClick}
              disableElevation
              sx={{
                bgcolor: "#f5272b",
                borderRadius: "2px",
                "&:hover": {
                  backgroundColor: "#f5272b",
                },
              }}
            >
              {btnTitle}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};
